<ng-container *ngIf="vo$ | async; let vo">
	<dx-data-grid
		[elementAttr]="{
			id: 'member-list',
			class: 'member-list'
		}"
		[dataSource]="dataSource"
		[remoteOperations]="{ paging: true, filtering: true, sorting: true }"
		[filterRow]="{ visible: true, applyFilter: 'auto' }"
		[headerFilter]="{ visible: true }"
		[hoverStateEnabled]="true"
		[showColumnHeaders]="true"
		[allowColumnResizing]="true"
		[columnAutoWidth]="false"
		[showRowLines]="false"
		[showColumnLines]="false"
		[rowAlternationEnabled]="false"
		[showBorders]="false"
		[width]="'100%'"
		[repaintChangesOnly]="true"
		(onOptionChanged)="onGridOptionChange($event)"
		(onContentReady)="onContentReady($event)"
		(onSelectionChanged)="onSelectionChanged()">
		<dxo-selection
			mode="multiple"
			selectAllMode="page"
			showCheckBoxesMode="always"></dxo-selection>

		<dxo-header-filter [visible]="true"></dxo-header-filter>

		<dxo-load-panel
			shadingColor="rgba(0,0,0,0)"
			[indicatorSrc]="DcLoaders.LoaderInfinite"
			[height]="100"
			[width]="100"
			[enabled]="true"
			[showIndicator]="true"
			[showPane]="true"
			[shading]="true"></dxo-load-panel>

		<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

		<ng-container *ngFor="let col of vo.memberList.availableColumns | toArray">
			<dxi-column
				*ngIf="col.field === 'login'"
				[dataField]="col.field"
				[dataType]="col.type"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[visible]="col.visible"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="col.canBeReordered"
				[allowHeaderFiltering]="col.hasHeaderFilter"
				[filterOperations]="StringFilterOperations"
				[format]="col.format"
				[alignment]="'left'"
				[visibleIndex]="col.visibleIndex"
				[width]="'20%'"
				cellTemplate="loginTemplate"></dxi-column>

			<dxi-column
				*ngIf="col.field === 'lastName'"
				[dataField]="col.field"
				[dataType]="col.type"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[visible]="col.visible"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="col.canBeReordered"
				[allowHeaderFiltering]="col.hasHeaderFilter"
				[filterOperations]="StringFilterOperations"
				[format]="col.format"
				[alignment]="'left'"
				[visibleIndex]="col.visibleIndex"
				[width]="'15%'"></dxi-column>

			<dxi-column
				*ngIf="col.field === 'firstName'"
				[dataField]="col.field"
				[dataType]="col.type"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[visible]="col.visible"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="col.canBeReordered"
				[allowHeaderFiltering]="col.hasHeaderFilter"
				[filterOperations]="StringFilterOperations"
				[format]="col.format"
				[alignment]="'left'"
				[visibleIndex]="col.visibleIndex"
				[width]="'15%'"></dxi-column>

			<dxi-column
				*ngIf="col.field === 'mail'"
				[dataField]="col.field"
				[dataType]="col.type"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[visible]="col.visible"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="col.canBeReordered"
				[allowHeaderFiltering]="col.hasHeaderFilter"
				[filterOperations]="StringFilterOperations"
				[format]="col.format"
				[alignment]="'left'"
				[visibleIndex]="col.visibleIndex"
				[width]="'20%'"></dxi-column>

			<dxi-column
				*ngIf="col.field === 'name'"
				[dataField]="col.field"
				[dataType]="col.type"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[visible]="col.visible"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="col.canBeReordered"
				[allowHeaderFiltering]="col.hasHeaderFilter"
				[filterOperations]="StringFilterOperations"
				[alignment]="'left'"
				[visibleIndex]="col.visibleIndex"
				[width]="'25%'"></dxi-column>

			<dxi-column
				*ngIf="col.field === 'description'"
				[dataField]="col.field"
				[dataType]="col.type"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[visible]="col.visible"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="col.canBeReordered"
				[allowHeaderFiltering]="col.hasHeaderFilter"
				[filterOperations]="StringFilterOperations"
				[alignment]="'left'"
				[visibleIndex]="col.visibleIndex"
				[width]="'45%'"></dxi-column>

			<dxi-column
				*ngIf="col.field === 'creationDate'"
				[dataField]="col.field"
				[dataType]="col.type"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[visible]="col.visible"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="col.canBeReordered"
				[allowHeaderFiltering]="col.hasHeaderFilter"
				[filterOperations]="DateFilterOperations"
				[format]="col.format"
				[alignment]="'left'"
				[visibleIndex]="col.visibleIndex"
				[width]="'15%'"
				cellTemplate="creationDateTemplate"></dxi-column>

			<dxi-column
				*ngIf="col.field === 'updateDate'"
				[dataField]="col.field"
				[dataType]="col.type"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[visible]="col.visible"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="col.canBeReordered"
				[allowHeaderFiltering]="col.hasHeaderFilter"
				[filterOperations]="DateFilterOperations"
				[format]="col.format"
				[alignment]="'left'"
				[visibleIndex]="col.visibleIndex"
				[width]="'15%'"
				cellTemplate="updateDateTemplate"></dxi-column>
		</ng-container>

		<div class="login-template" *dxTemplate="let cell of 'loginTemplate'">
			<app-avatar
				*ngIf="cell.data['avatar']"
				[avatar]="cell.data['avatar']"
				[withTooltip]="true"></app-avatar>
			<span>
				{{ cell.data['login'] }}
			</span>
		</div>

		<div *dxTemplate="let cell of 'creationDateTemplate'">
			<span *ngIf="cell.data['creationDate']">
				{{ cell.data['creationDate'] | dayjsDate: 'DateTime' }}
			</span>
		</div>

		<div *dxTemplate="let cell of 'updateDateTemplate'">
			<span *ngIf="cell.data['updateDate']">
				{{ cell.data['updateDate'] | dayjsDate: 'DateTime' }}
			</span>
		</div>

		<dxo-group-panel [visible]="false"></dxo-group-panel>

		<!-- Filterable columns	-->
		<dxo-filter-row
			[visible]="vo.memberList.availableColumns.size !== 0"></dxo-filter-row>

		<!-- Sorting	-->
		<dxo-sorting mode="multiple"></dxo-sorting>

		<!-- Pagination -->
		<dxo-paging [pageSize]="20" [pageIndex]="0"></dxo-paging>
		<dxo-pager
			[visible]="true"
			[showPageSizeSelector]="true"
			[allowedPageSizes]="allowedPageSizes"
			[showInfo]="true"
			[showNavigationButtons]="true"></dxo-pager>

		<dxo-filter-panel [visible]="true"></dxo-filter-panel>
	</dx-data-grid>
</ng-container>
